module.exports = __webpack_public_path__ + "img/bg3.5862e6c8.png";